
function initEstimatedDelivery() {
  document.querySelectorAll(".estimated-delivery").forEach((wrapper) => {

    if (wrapper.dataset.initialized) return;
    wrapper.dataset.initialized = "true";

    const input = wrapper.querySelector(".pincode-eta-input");
    const button = wrapper.querySelector(".estimated-delivery-button");
    const result = wrapper.querySelector(".delivery-result");
    const form = wrapper.querySelector(".delivery-input-wrapper");

    if (!input || !button || !result || !form) return;

    let pincodeData = [];

    input.addEventListener("input", () => {
      if (!input.value) result.innerHTML = "";
    });

    button.addEventListener("click", async () => {
      if (!input.value) {
        result.innerHTML =
          "<p class='pincode-error error'>Please enter pincode.</p>";
        return;
      }

      button.textContent = "Checking...";

      if (!pincodeData.length) {
        const response = await fetch(form.dataset.express);
        pincodeData = await response.json();
      }

      findETA(input.value, pincodeData, result);

      button.textContent = "Check";
    });
  });
}
function findETA(pinCode, data, result) {
  const pin = data.find(
    item => parseInt(item.P) === parseInt(pinCode)
  );

  if (pin) {
    const currentDate = window.currentDate
      ? new Date(window.currentDate)
      : new Date();

    currentDate.setDate(
      currentDate.getDate() + parseInt(pin.T) + 3
    );

    result.innerHTML = `
      <p class="pincode-success success">
        Order Now — Arrives by ${getDateWithSuffix(
          currentDate.getDate()
        )} ${monthNames[currentDate.getMonth()]}
      </p>
    `;
  } else {
    result.innerHTML =
      "<p class='pincode-error error'>We are currently not delivering to this pin code.</p>";
  }
}

function getDateWithSuffix(day) {
  if (day >= 11 && day <= 13) return `${day}th`;

  switch (day % 10) {
    case 1:
      return `${day}st`;
    case 2:
      return `${day}nd`;
    case 3:
      return `${day}rd`;
    default:
      return `${day}th`;
  }
}

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];


document.addEventListener("DOMContentLoaded", () => {
  initEstimatedDelivery();
});

document.addEventListener("shopify:section:load", () => {
  initEstimatedDelivery();
});
const observer = new MutationObserver(() => {
  initEstimatedDelivery();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});